export const PENDING_SEAT_ACTION = 'PENDING_SEAT_ACTION'
export const RESET_SEAT_ACTION = 'RESET_SEAT_ACTION'
export const SET_SEAT_DATA = 'SET_SEAT_DATA'
